import { Input } from "src/features/calculator/types/formula"

const RENT_THRESHOLD = 60_000
const WITHOUT_AD_HIGH_RATE = 0.66
const WITHOUT_AD_LOW_RATE = 0.6
const WITH_AD_HIGH_RATE = 0.77
const WITH_AD_LOW_RATE = 0.7

// リアハウス(ADなし)
// 送客手数料率(税込) = もし家賃が > 60000ならば0.66それ以外は0.6
export function calcCustomerTransferFeeRateWithoutAD({ rent }: Input): number {
  return rent > RENT_THRESHOLD ? WITHOUT_AD_HIGH_RATE : WITHOUT_AD_LOW_RATE
}

// リアハウス(ADあり)
// 送客手数料率(税込) = もし家賃が > 60000ならば0.77それ以外は0.7
export function calcCustomerTransferFeeRateWithAD({ rent }: Input): number {
  return rent > RENT_THRESHOLD ? WITH_AD_HIGH_RATE : WITH_AD_LOW_RATE
}
